/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CampaignAPI {

  /**
   * Method that creates a new campaign
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaign(
    requestBody?: {
      id?: number;
      type?: 'Default' | 'Deal' | 'RTB';
      inventory_type_id?: 'display' | 'video' | 'dooh' | 'ctv';
      delivery_model?: 'cpm' | 'cpc' | 'flat' | 'cpv' | 'vcpm';
      targeting_level_id?: 'ron' | 'roc' | 'ros';
      language_id?: string | null;
      platform_id?: number;
      rate?: number | null;
      budget?: number | null;
      max_daily_spend?: number | null;
      total_spend?: number | null;
      bids?: number | null;
      user_id?: number | null;
      representative_id?: number | null;
      advertiser_id?: number | null;
      advertiser_domain_id?: number | null;
      order_id?: number | null;
      status_id?: 'active' | 'cancelled' | 'expired' | 'pending' | 'planning' | 'pricing' | 'reservation' | 'review' | 'temporary';
      is_paused?: boolean;
      content_type_id?: number;
      priority_chain_id?: 'low' | 'network' | 'channel' | 'permanent' | 'targeted' | 'rush';
      buyer_id?: number | null;
      weight?: number | null;
      paid?: boolean;
      price?: number | null;
      pricing_bundle_id?: number | null;
      start_date?: string | null;
      end_date?: string | null;
      views?: number;
      max_views?: number | null;
      clicks?: number;
      max_clicks?: number | null;
      viewed_impressions?: number;
      max_viewed_impressions?: number | null;
      viewability_goal?: number;
      override_viewability_optimization?: boolean;
      refreshed_impressions?: number;
      undetermined_impressions?: number;
      quebec_sales_tax?: number | null;
      goods_services_tax?: number | null;
      net_price?: number | null;
      product?: string | null;
      client?: string | null;
      contract_id?: string | null;
      created_at?: string;
      confirmed_at?: string | null;
      media_notice_sent_days?: number | null;
      billed_at?: string | null;
      cap_premium?: number | null;
      has_preferencial_rate?: boolean;
      is_videoegg?: boolean;
      is_monetized?: boolean;
      notes?: string | null;
      keywords?: string | null;
      block_prioritizer?: boolean;
      equalizing_filter?: boolean;
      hours_filter?: Array<number>;
      minutes_filter?: Array<number>;
      weekdays_filter?: Array<'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday'>;
      geo_filter?: string | null;
      ip_filter?: string | null;
      sequential_filter?: boolean;
      min_celsius?: number | null;
      max_celsius?: number | null;
      auto_target?: boolean;
      chain_active?: boolean;
      is_rtb_active?: boolean;
      is_rtb_fullscreen?: boolean;
      is_bidding_only_on_deals?: boolean;
      delivery_fee_active?: boolean;
      blocks_auto_refresh?: boolean;
      browser_language_filter?: string | null;
      dooh_audience_age?: number | null;
      dooh_audience_radius?: number | null;
      dooh_audience_ratio?: number | null;
      dooh_use_pompe_template?: boolean;
      currency_id?: string;
      cad_total_spend?: number | null;
      ui_settings?: any;
      updated_at?: string;
      last_edited_at?: string;
      description?: string | null;
    },
  ): CancelablePromise<{
    id: number;
    type: 'Default' | 'Deal' | 'RTB';
    inventory_type_id: 'display' | 'video' | 'dooh' | 'ctv';
    delivery_model: 'cpm' | 'cpc' | 'flat' | 'cpv' | 'vcpm';
    targeting_level_id: 'ron' | 'roc' | 'ros' | null;
    language_id: string | null;
    platform_id: number;
    rate: number | null;
    budget: number | null;
    max_daily_spend: number | null;
    total_spend: number | null;
    bids: number | null;
    user_id: number | null;
    representative_id: number | null;
    advertiser_id: number | null;
    advertiser_domain_id: number | null;
    order_id: number | null;
    status_id: 'active' | 'cancelled' | 'expired' | 'pending' | 'planning' | 'pricing' | 'reservation' | 'review' | 'temporary';
    is_paused: boolean;
    content_type_id: number;
    priority_chain_id: 'low' | 'network' | 'channel' | 'permanent' | 'targeted' | 'rush';
    buyer_id: number | null;
    weight: number | null;
    paid: boolean;
    price: number | null;
    pricing_bundle_id: number | null;
    start_date: string | null;
    end_date: string | null;
    views: number;
    max_views: number | null;
    clicks: number;
    max_clicks: number | null;
    viewed_impressions: number;
    max_viewed_impressions: number | null;
    viewability_goal: number;
    override_viewability_optimization: boolean;
    refreshed_impressions: number;
    undetermined_impressions: number;
    quebec_sales_tax: number | null;
    goods_services_tax: number | null;
    net_price: number | null;
    product: string | null;
    client: string | null;
    contract_id: string | null;
    created_at: string;
    confirmed_at: string | null;
    media_notice_sent_days: number | null;
    billed_at: string | null;
    cap_premium: number | null;
    has_preferencial_rate: boolean;
    is_videoegg: boolean;
    is_monetized: boolean;
    notes: string | null;
    keywords: string | null;
    block_prioritizer: boolean;
    equalizing_filter: boolean;
    hours_filter: Array<number>;
    minutes_filter: Array<number>;
    weekdays_filter: Array<'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday'>;
    geo_filter: string | null;
    ip_filter: string | null;
    sequential_filter: boolean;
    min_celsius: number | null;
    max_celsius: number | null;
    auto_target: boolean;
    chain_active: boolean;
    is_rtb_active: boolean;
    is_rtb_fullscreen: boolean;
    is_bidding_only_on_deals: boolean;
    delivery_fee_active: boolean;
    blocks_auto_refresh: boolean;
    browser_language_filter: string | null;
    dooh_audience_age: number | null;
    dooh_audience_radius: number | null;
    dooh_audience_ratio: number | null;
    dooh_use_pompe_template: boolean;
    currency_id: string;
    cad_total_spend: number | null;
    ui_settings: any;
    updated_at: string;
    last_edited_at: string;
    description: string | null;
    order?: {
      agency_id?: number | null;
      name?: string | null;
      advertiser?: {
        name?: string;
      };
    } | null;
    campaign_user_tag: Array<{
      campaign_id: number;
      user_tag_id: number;
      user_tag?: {
        name: string;
      };
    }>;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that updates a particular campaign
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiCampaign(
    requestBody: {
      id: number;
      type?: 'Default' | 'Deal' | 'RTB';
      inventory_type_id?: 'display' | 'video' | 'dooh' | 'ctv';
      delivery_model?: 'cpm' | 'cpc' | 'flat' | 'cpv' | 'vcpm';
      targeting_level_id?: 'ron' | 'roc' | 'ros';
      language_id?: string | null;
      platform_id?: number;
      rate?: number | null;
      budget?: number | null;
      max_daily_spend?: number | null;
      total_spend?: number | null;
      bids?: number | null;
      user_id?: number | null;
      representative_id?: number | null;
      advertiser_id?: number | null;
      advertiser_domain_id?: number | null;
      order_id?: number | null;
      status_id?: 'active' | 'cancelled' | 'expired' | 'pending' | 'planning' | 'pricing' | 'reservation' | 'review' | 'temporary';
      is_paused?: boolean;
      content_type_id?: number;
      priority_chain_id?: 'low' | 'network' | 'channel' | 'permanent' | 'targeted' | 'rush';
      buyer_id?: number | null;
      weight?: number | null;
      paid?: boolean;
      price?: number | null;
      pricing_bundle_id?: number | null;
      start_date?: string | null;
      end_date?: string | null;
      views?: number;
      max_views?: number | null;
      clicks?: number;
      max_clicks?: number | null;
      viewed_impressions?: number;
      max_viewed_impressions?: number | null;
      viewability_goal?: number;
      override_viewability_optimization?: boolean;
      refreshed_impressions?: number;
      undetermined_impressions?: number;
      quebec_sales_tax?: number | null;
      goods_services_tax?: number | null;
      net_price?: number | null;
      product?: string | null;
      client?: string | null;
      contract_id?: string | null;
      created_at?: string;
      confirmed_at?: string | null;
      media_notice_sent_days?: number | null;
      billed_at?: string | null;
      cap_premium?: number | null;
      has_preferencial_rate?: boolean;
      is_videoegg?: boolean;
      is_monetized?: boolean;
      notes?: string | null;
      keywords?: string | null;
      block_prioritizer?: boolean;
      equalizing_filter?: boolean;
      hours_filter?: Array<number>;
      minutes_filter?: Array<number>;
      weekdays_filter?: Array<'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday'>;
      geo_filter?: string | null;
      ip_filter?: string | null;
      sequential_filter?: boolean;
      min_celsius?: number | null;
      max_celsius?: number | null;
      auto_target?: boolean;
      chain_active?: boolean;
      is_rtb_active?: boolean;
      is_rtb_fullscreen?: boolean;
      is_bidding_only_on_deals?: boolean;
      delivery_fee_active?: boolean;
      blocks_auto_refresh?: boolean;
      browser_language_filter?: string | null;
      dooh_audience_age?: number | null;
      dooh_audience_radius?: number | null;
      dooh_audience_ratio?: number | null;
      dooh_use_pompe_template?: boolean;
      currency_id?: string;
      cad_total_spend?: number | null;
      ui_settings?: any;
      updated_at?: string;
      last_edited_at?: string;
      description?: string | null;
    },
  ): CancelablePromise<{
    id: number;
    type: 'Default' | 'Deal' | 'RTB';
    inventory_type_id: 'display' | 'video' | 'dooh' | 'ctv';
    delivery_model: 'cpm' | 'cpc' | 'flat' | 'cpv' | 'vcpm';
    targeting_level_id: 'ron' | 'roc' | 'ros' | null;
    language_id: string | null;
    platform_id: number;
    rate: number | null;
    budget: number | null;
    max_daily_spend: number | null;
    total_spend: number | null;
    bids: number | null;
    user_id: number | null;
    representative_id: number | null;
    advertiser_id: number | null;
    advertiser_domain_id: number | null;
    order_id: number | null;
    status_id: 'active' | 'cancelled' | 'expired' | 'pending' | 'planning' | 'pricing' | 'reservation' | 'review' | 'temporary';
    is_paused: boolean;
    content_type_id: number;
    priority_chain_id: 'low' | 'network' | 'channel' | 'permanent' | 'targeted' | 'rush';
    buyer_id: number | null;
    weight: number | null;
    paid: boolean;
    price: number | null;
    pricing_bundle_id: number | null;
    start_date: string | null;
    end_date: string | null;
    views: number;
    max_views: number | null;
    clicks: number;
    max_clicks: number | null;
    viewed_impressions: number;
    max_viewed_impressions: number | null;
    viewability_goal: number;
    override_viewability_optimization: boolean;
    refreshed_impressions: number;
    undetermined_impressions: number;
    quebec_sales_tax: number | null;
    goods_services_tax: number | null;
    net_price: number | null;
    product: string | null;
    client: string | null;
    contract_id: string | null;
    created_at: string;
    confirmed_at: string | null;
    media_notice_sent_days: number | null;
    billed_at: string | null;
    cap_premium: number | null;
    has_preferencial_rate: boolean;
    is_videoegg: boolean;
    is_monetized: boolean;
    notes: string | null;
    keywords: string | null;
    block_prioritizer: boolean;
    equalizing_filter: boolean;
    hours_filter: Array<number>;
    minutes_filter: Array<number>;
    weekdays_filter: Array<'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday'>;
    geo_filter: string | null;
    ip_filter: string | null;
    sequential_filter: boolean;
    min_celsius: number | null;
    max_celsius: number | null;
    auto_target: boolean;
    chain_active: boolean;
    is_rtb_active: boolean;
    is_rtb_fullscreen: boolean;
    is_bidding_only_on_deals: boolean;
    delivery_fee_active: boolean;
    blocks_auto_refresh: boolean;
    browser_language_filter: string | null;
    dooh_audience_age: number | null;
    dooh_audience_radius: number | null;
    dooh_audience_ratio: number | null;
    dooh_use_pompe_template: boolean;
    currency_id: string;
    cad_total_spend: number | null;
    ui_settings: any;
    updated_at: string;
    last_edited_at: string;
    description: string | null;
    order?: {
      agency_id?: number | null;
      name?: string | null;
      advertiser?: {
        name?: string;
      };
    } | null;
    campaign_user_tag: Array<{
      campaign_id: number;
      user_tag_id: number;
      user_tag?: {
        name: string;
      };
    }>;
  }> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/campaign',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns a particular campaign
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCampaign(
    id: number,
  ): CancelablePromise<{
    id: number;
    type: 'Default' | 'Deal' | 'RTB';
    inventory_type_id: 'display' | 'video' | 'dooh' | 'ctv';
    delivery_model: 'cpm' | 'cpc' | 'flat' | 'cpv' | 'vcpm';
    targeting_level_id: 'ron' | 'roc' | 'ros' | null;
    language_id: string | null;
    platform_id: number;
    rate: number | null;
    budget: number | null;
    max_daily_spend: number | null;
    total_spend: number | null;
    bids: number | null;
    user_id: number | null;
    representative_id: number | null;
    advertiser_id: number | null;
    advertiser_domain_id: number | null;
    order_id: number | null;
    status_id: 'active' | 'cancelled' | 'expired' | 'pending' | 'planning' | 'pricing' | 'reservation' | 'review' | 'temporary';
    is_paused: boolean;
    content_type_id: number;
    priority_chain_id: 'low' | 'network' | 'channel' | 'permanent' | 'targeted' | 'rush';
    buyer_id: number | null;
    weight: number | null;
    paid: boolean;
    price: number | null;
    pricing_bundle_id: number | null;
    start_date: string | null;
    end_date: string | null;
    views: number;
    max_views: number | null;
    clicks: number;
    max_clicks: number | null;
    viewed_impressions: number;
    max_viewed_impressions: number | null;
    viewability_goal: number;
    override_viewability_optimization: boolean;
    refreshed_impressions: number;
    undetermined_impressions: number;
    quebec_sales_tax: number | null;
    goods_services_tax: number | null;
    net_price: number | null;
    product: string | null;
    client: string | null;
    contract_id: string | null;
    created_at: string;
    confirmed_at: string | null;
    media_notice_sent_days: number | null;
    billed_at: string | null;
    cap_premium: number | null;
    has_preferencial_rate: boolean;
    is_videoegg: boolean;
    is_monetized: boolean;
    notes: string | null;
    keywords: string | null;
    block_prioritizer: boolean;
    equalizing_filter: boolean;
    hours_filter: Array<number>;
    minutes_filter: Array<number>;
    weekdays_filter: Array<'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday'>;
    geo_filter: string | null;
    ip_filter: string | null;
    sequential_filter: boolean;
    min_celsius: number | null;
    max_celsius: number | null;
    auto_target: boolean;
    chain_active: boolean;
    is_rtb_active: boolean;
    is_rtb_fullscreen: boolean;
    is_bidding_only_on_deals: boolean;
    delivery_fee_active: boolean;
    blocks_auto_refresh: boolean;
    browser_language_filter: string | null;
    dooh_audience_age: number | null;
    dooh_audience_radius: number | null;
    dooh_audience_ratio: number | null;
    dooh_use_pompe_template: boolean;
    currency_id: string;
    cad_total_spend: number | null;
    ui_settings: any;
    updated_at: string;
    last_edited_at: string;
    description: string | null;
    order?: {
      agency_id?: number | null;
      name?: string | null;
      advertiser?: {
        name?: string;
      };
    } | null;
    campaign_user_tag: Array<{
      campaign_id: number;
      user_tag_id: number;
      user_tag?: {
        name: string;
      };
    }>;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/campaign/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that returns a list of campaign auction types
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCampaignAuctionTypeList(
    id: number,
  ): CancelablePromise<Array<{
    id: number;
    campaign_id: number;
    auction_type_id: number;
    created_at: string;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/campaign/{id}/auction/type/list',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that mass update a campaign auction types
   * @param id
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaignAuctionTypeList(
    id: number,
    requestBody?: Array<{
      id?: number;
      campaign_id: number;
      auction_type_id: number;
      created_at?: string;
    }>,
  ): CancelablePromise<Array<{
    id: number;
    campaign_id: number;
    auction_type_id: number;
    created_at: string;
  }>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign/{id}/auction/type/list',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns campaign audience areas
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCampaignAudienceAreaList(
    id: number,
  ): CancelablePromise<Array<{
    id: number;
    campaign_id: number;
    audience_area_id: number;
    is_inclusive: boolean;
    status_id: 'active' | 'inactive';
    created_at: string;
    audience_area?: {
      id: number;
      audience_id: number;
      name: string;
      lat: number;
      lon: number;
      radius: number;
      age: number;
      end_date: string | null;
      start_date: string | null;
      unique_visitors: number;
      visitors: number;
      processing_status: number;
      last_processing_date: string | null;
      is_deleted: boolean;
      site?: {
        id: number;
        type_id: number;
        user_id: number | null;
        account_manager_id: number | null;
        language_id: string | null;
        status_id: 'active' | 'approved' | 'inactive' | 'pending' | 'refused';
        agency_id: number | null;
        platform_id: number;
        is_audience: boolean;
        is_validating_domain: boolean;
        name: string;
        url: string;
        description: string;
        is_public_auction_level_active: boolean;
        is_private_auction_level_active: boolean;
        pageviews_per_month: number | null;
        visitors_per_month: number | null;
        visits_per_month: number | null;
        number_of_zones: number | null;
        zone_views_per_month: number | null;
        ping_delay: number | null;
        dooh_is_up: boolean;
        dooh_status_updated_at: string | null;
        dooh_high_sound_start: string | null;
        dooh_high_sound_end: string | null;
        dooh_high_sound_ratio: number | null;
        dooh_low_sound_ratio: number | null;
        dooh_start: string | null;
        dooh_end: string | null;
        dooh_queue_depth: number | null;
        impression_multiplier: number | null;
        created_at: string | null;
        updated_at: string | null;
        birth_date: string | null;
        stripped_name: string | null;
        videoegg_tag: string | null;
        flowplayer_license: string | null;
        comscore_tag_id: number | null;
        internal_views_ratio: number | null;
        custom_revenue_ratio: number | null;
        has_competitor: boolean;
        address: string | null;
        country_id: string | null;
        state_id: string | null;
        city_id: number | null;
        postal_code: string | null;
        latitude: number | null;
        longitude: number | null;
        manufacturer: string | null;
        dooh_is_videooh: boolean;
      };
    };
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/campaign/{id}/audience/area/list',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that mass update a campaign areas
   * @param id
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaignAudienceAreaList(
    id: number,
    requestBody?: Array<{
      id?: number;
      campaign_id: number;
      audience_area_id: number;
      is_inclusive?: boolean;
      status_id?: 'active' | 'inactive';
      created_at?: string;
    }>,
  ): CancelablePromise<Array<{
    id: number;
    campaign_id: number;
    audience_area_id: number;
    is_inclusive: boolean;
    status_id: 'active' | 'inactive';
    created_at: string;
  }>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign/{id}/audience/area/list',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns available campaign audiences
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCampaignAudienceAvailableList(
    id: number,
  ): CancelablePromise<Array<{
    id: number;
    is_audience: boolean;
    site?: {
      name: string;
      agency?: {
        name: string;
      } | null;
    } | null;
  } | null>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/campaign/{id}/audience/available/list',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that returns campaign audiences
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCampaignAudienceList(
    id: number,
  ): CancelablePromise<Array<{
    id: number;
    campaign_id: number;
    zone_id: number | null;
    tag_id: number | null;
    approval_status_id: 'active' | 'inactive';
    is_inclusive: boolean;
    created_at: string | null;
    zone?: {
      id: number;
      is_audience: boolean;
      site?: {
        name: string;
        agency?: {
          name: string;
        } | null;
      } | null;
    } | null;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/campaign/{id}/audience/list',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that returns campaign audience providers
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCampaignAudienceProviderList(
    id: number,
  ): CancelablePromise<Array<{
    id: number;
    campaign_id: number;
    provider_id: number;
    is_inclusive: boolean;
    status_id: 'active' | 'inactive';
    created_at: string;
    provider?: {
      id?: number;
      name?: string | null;
      pattern?: string | null;
    };
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/campaign/{id}/audience/provider/list',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that returns campaign caps
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCampaignCapList(
    id: number,
  ): CancelablePromise<Array<{
    id: number;
    campaign_id: number;
    frequency: number;
    units: number;
    period: 'second' | 'minute' | 'quarter' | 'hour' | 'day' | 'week' | 'month' | 'campaign';
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/campaign/{id}/cap/list',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaignCapList(
    id: number,
    requestBody?: Array<{
      id?: number;
      campaign_id: number;
      frequency: number;
      units?: number;
      period: 'second' | 'minute' | 'quarter' | 'hour' | 'day' | 'week' | 'month' | 'campaign';
    }>,
  ): CancelablePromise<Array<{
    id: number;
    campaign_id: number;
    frequency: number;
    units: number;
    period: 'second' | 'minute' | 'quarter' | 'hour' | 'day' | 'week' | 'month' | 'campaign';
  }>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign/{id}/cap/list',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns cities shapes associated to a campaign
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCampaignCityShapeList(
    id: number,
  ): CancelablePromise<Array<{
    id: number;
    campaign_id: number;
    created_at: string;
    is_active: boolean;
    is_deleted: boolean;
    city_shape_id: number;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/campaign/{id}/city_shape/list',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that mass update a campaign city shapes
   * @param id
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaignCityShapeList(
    id: number,
    requestBody?: Array<{
      id?: number;
      campaign_id: number;
      created_at?: string;
      is_active?: boolean;
      is_deleted?: boolean;
      city_shape_id: number;
    }>,
  ): CancelablePromise<Array<{
    id: number;
    campaign_id: number;
    created_at: string;
    is_active: boolean;
    is_deleted: boolean;
    city_shape_id: number;
  }>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign/{id}/city_shape/list',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns possible campaign competitors
   * @param id
   * @returns number Default Response
   * @throws ApiError
   */
  public static getApiCampaignCompetitorList(
    id: number,
  ): CancelablePromise<Array<number>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/campaign/{id}/competitor/list',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that returns campaign coordinates
   * @param id
   * @param isDeleted
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCampaignCoordinateList(
    id: number,
    isDeleted: boolean = false,
  ): CancelablePromise<Array<{
    id: number;
    campaign_id: number;
    name: string;
    radius: number;
    latitude: number;
    longitude: number;
    created_at: string | null;
    updated_at: string | null;
    is_deleted: boolean;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/campaign/{id}/coordinate/list',
      path: {
        'id': id,
      },
      query: {
        'is_deleted': isDeleted,
      },
    });
  }

  /**
   * Method that mass update all campaign coordinates
   * @param id
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaignCoordinateList(
    id: number,
    requestBody?: Array<{
      id?: number;
      campaign_id: number;
      name?: string;
      radius: number;
      latitude?: number;
      longitude?: number;
      created_at?: string | null;
      updated_at?: string | null;
      is_deleted?: boolean;
    }>,
  ): CancelablePromise<Array<{
    id: number;
    campaign_id: number;
    name: string;
    radius: number;
    latitude: number;
    longitude: number;
    created_at: string | null;
    updated_at: string | null;
    is_deleted: boolean;
  }>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign/{id}/coordinate/list',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that mass update all campaign coordinates
   * @param id
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaignCoordinateListPreview(
    id: number,
    requestBody?: Array<{
      id?: number;
      campaign_id: number;
      name?: string;
      radius: number;
      latitude?: number;
      longitude?: number;
      created_at?: string | null;
      updated_at?: string | null;
      is_deleted?: boolean;
    }>,
  ): CancelablePromise<{
    updates: number;
    inserts: number;
    deletes: number;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign/{id}/coordinate/list/preview',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns countries shapes associated to a campaign
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCampaignCountryShapeList(
    id: number,
  ): CancelablePromise<Array<{
    id: number;
    campaign_id: number;
    created_at: string;
    is_active: boolean;
    is_deleted: boolean;
    country_id: string;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/campaign/{id}/country_shape/list',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that mass update a campaign country shapes
   * @param id
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaignCountryShapeList(
    id: number,
    requestBody?: Array<{
      id?: number;
      campaign_id: number;
      created_at?: string;
      is_active?: boolean;
      is_deleted?: boolean;
      country_id: string;
    }>,
  ): CancelablePromise<Array<{
    id: number;
    campaign_id: number;
    created_at: string;
    is_active: boolean;
    is_deleted: boolean;
    country_id: string;
  }>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign/{id}/country_shape/list',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that creates a duplicate of a campaign
   * @param id
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaignDuplicate(
    id: number,
    requestBody: {
      status_id: 'active' | 'cancelled' | 'expired' | 'pending' | 'planning' | 'pricing' | 'reservation' | 'review' | 'temporary';
      no_duplicate?: Array<'ssp' | 'deal' | 'publisher' | 'media' | 'zones'>;
    },
  ): CancelablePromise<{
    id: number;
    type: 'Default' | 'Deal' | 'RTB';
    inventory_type_id: 'display' | 'video' | 'dooh' | 'ctv';
    delivery_model: 'cpm' | 'cpc' | 'flat' | 'cpv' | 'vcpm';
    targeting_level_id: 'ron' | 'roc' | 'ros' | null;
    language_id: string | null;
    platform_id: number;
    rate: number | null;
    budget: number | null;
    max_daily_spend: number | null;
    total_spend: number | null;
    bids: number | null;
    user_id: number | null;
    representative_id: number | null;
    advertiser_id: number | null;
    advertiser_domain_id: number | null;
    order_id: number | null;
    status_id: 'active' | 'cancelled' | 'expired' | 'pending' | 'planning' | 'pricing' | 'reservation' | 'review' | 'temporary';
    is_paused: boolean;
    content_type_id: number;
    priority_chain_id: 'low' | 'network' | 'channel' | 'permanent' | 'targeted' | 'rush';
    buyer_id: number | null;
    weight: number | null;
    paid: boolean;
    price: number | null;
    pricing_bundle_id: number | null;
    start_date: string | null;
    end_date: string | null;
    views: number;
    max_views: number | null;
    clicks: number;
    max_clicks: number | null;
    viewed_impressions: number;
    max_viewed_impressions: number | null;
    viewability_goal: number;
    override_viewability_optimization: boolean;
    refreshed_impressions: number;
    undetermined_impressions: number;
    quebec_sales_tax: number | null;
    goods_services_tax: number | null;
    net_price: number | null;
    product: string | null;
    client: string | null;
    contract_id: string | null;
    created_at: string;
    confirmed_at: string | null;
    media_notice_sent_days: number | null;
    billed_at: string | null;
    cap_premium: number | null;
    has_preferencial_rate: boolean;
    is_videoegg: boolean;
    is_monetized: boolean;
    notes: string | null;
    keywords: string | null;
    block_prioritizer: boolean;
    equalizing_filter: boolean;
    hours_filter: Array<number>;
    minutes_filter: Array<number>;
    weekdays_filter: Array<'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday'>;
    geo_filter: string | null;
    ip_filter: string | null;
    sequential_filter: boolean;
    min_celsius: number | null;
    max_celsius: number | null;
    auto_target: boolean;
    chain_active: boolean;
    is_rtb_active: boolean;
    is_rtb_fullscreen: boolean;
    is_bidding_only_on_deals: boolean;
    delivery_fee_active: boolean;
    blocks_auto_refresh: boolean;
    browser_language_filter: string | null;
    dooh_audience_age: number | null;
    dooh_audience_radius: number | null;
    dooh_audience_ratio: number | null;
    dooh_use_pompe_template: boolean;
    currency_id: string;
    cad_total_spend: number | null;
    ui_settings: any;
    updated_at: string;
    last_edited_at: string;
    description: string | null;
    order?: {
      agency_id?: number | null;
      name?: string | null;
      advertiser?: {
        name?: string;
      };
    } | null;
    campaign_user_tag: Array<{
      campaign_id: number;
      user_tag_id: number;
      user_tag?: {
        name: string;
      };
    }>;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign/{id}/duplicate',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns campaign geography
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCampaignGeographyList(
    id: number,
  ): CancelablePromise<Array<{
    id: number;
    campaign_id: number;
    country_id: string | null;
    state_id: string | null;
    city_id: number | null;
    country?: {
      id: string;
      name: string;
      alpha3: string | null;
      latitude: number;
      longitude: number;
    };
    state?: {
      country_id: string;
      id: string;
      name: string | null;
      latitude: number;
      longitude: number;
    };
    city?: {
      id: number;
      country: string;
      state: string;
      name: string;
    };
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/campaign/{id}/geography/list',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that returns campaign media fees
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCampaignMediaFeeList(
    id: number,
  ): CancelablePromise<Array<{
    id: number;
    campaign_id: number;
    description: string;
    amount: number;
    type: string;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/campaign/{id}/media_fee/list',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that returns campaign media
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCampaignMediaList(
    id: number,
  ): CancelablePromise<Array<{
    id?: number;
    campaign_id: number;
    media_id: number;
    parent_campaign_media_id?: number | null;
    is_companion?: boolean;
    approval_status_id?: 'active' | 'inactive' | 'pending' | 'refused';
    views?: number;
    clicks?: number;
    viewed_impressions?: number;
    refreshed_impressions?: number;
    undetermined_impressions?: number;
    created_at?: string;
    zone_id?: number | null;
    clickthrough_url?: string | null;
    start_date?: string | null;
    end_date?: string | null;
    max_impressions_ratio?: number;
    is_video_playing_out_of_view?: boolean;
    is_video_looping?: boolean;
    inline_pause_to_overlay?: boolean;
    refusal_notes?: string | null;
    media?: {
      id?: number;
      name?: string | null;
      content_type_id: number;
      media_type_id: number;
      format_id?: number | null;
      mime_type?: string | null;
      preview_image_path?: string | null;
      media?: string | null;
      headline?: string | null;
      display_url?: string | null;
      duration?: number | null;
      created_at?: string | null;
      is_replacement?: boolean;
      is_deleted?: boolean;
      is_secure?: boolean;
      owner_id?: number | null;
      agency_id?: number | null;
      platform_id?: number;
      filesize?: number | null;
      height?: number | null;
      width?: number | null;
      videooh_encoding_status?: 'encoding' | 'error' | 'done' | null;
      videooh_media?: string | null;
      is_draft?: boolean;
      media_creative?: Array<{
        id?: number;
        media_id: number;
        mime_type?: string | null;
        name?: string | null;
        path?: string | null;
        created_at?: string | null;
      }>;
      format?: {
        id?: number;
        width: number;
        height: number;
        orientation?: 'vertical' | 'horizontal' | 'both' | null;
        text_slot?: number;
        allow_text?: boolean;
        allow_image?: boolean;
        allow_flash?: boolean;
        active?: boolean;
        stripped_name?: string | null;
        name?: string | null;
        order?: number | null;
        allow_as_media?: boolean;
        allow_publisher?: boolean;
        is_public?: boolean;
        extend_format_id?: number | null;
        native_template?: string | null;
        is_admin_dsp?: boolean;
      } | null;
      media_video?: Array<{
        id?: number;
        media_id: number;
        mime_type: string;
        file_path: string;
        duration?: number | null;
        width: number;
        height: number;
        bitrate?: number | null;
        filesize?: number | null;
        created_at?: string;
      }>;
    };
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/campaign/{id}/media/list',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that mass update a campaign medias
   * @param id
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaignMediaList(
    id: number,
    requestBody?: Array<{
      id?: number;
      campaign_id: number;
      media_id: number;
      parent_campaign_media_id?: number | null;
      is_companion?: boolean;
      approval_status_id?: 'active' | 'inactive' | 'pending' | 'refused';
      views?: number;
      clicks?: number;
      viewed_impressions?: number;
      refreshed_impressions?: number;
      undetermined_impressions?: number;
      created_at?: string;
      zone_id?: number | null;
      clickthrough_url?: string | null;
      start_date?: string | null;
      end_date?: string | null;
      max_impressions_ratio?: number;
      is_video_playing_out_of_view?: boolean;
      is_video_looping?: boolean;
      inline_pause_to_overlay?: boolean;
      refusal_notes?: string | null;
    }>,
  ): CancelablePromise<Array<{
    id: number;
    campaign_id: number;
    media_id: number;
    parent_campaign_media_id: number | null;
    is_companion: boolean;
    approval_status_id: 'active' | 'inactive' | 'pending' | 'refused';
    views: number;
    clicks: number;
    viewed_impressions: number;
    refreshed_impressions: number;
    undetermined_impressions: number;
    created_at: string;
    zone_id: number | null;
    clickthrough_url: string | null;
    start_date: string | null;
    end_date: string | null;
    max_impressions_ratio: number;
    is_video_playing_out_of_view: boolean;
    is_video_looping: boolean;
    inline_pause_to_overlay: boolean;
    refusal_notes: string | null;
    media?: {
      id?: number;
      name?: string | null;
      content_type_id: number;
      media_type_id: number;
      format_id?: number | null;
      mime_type?: string | null;
      preview_image_path?: string | null;
      media?: string | null;
      headline?: string | null;
      display_url?: string | null;
      duration?: number | null;
      created_at?: string | null;
      is_replacement?: boolean;
      is_deleted?: boolean;
      is_secure?: boolean;
      owner_id?: number | null;
      agency_id?: number | null;
      platform_id?: number;
      filesize?: number | null;
      height?: number | null;
      width?: number | null;
      videooh_encoding_status?: 'encoding' | 'error' | 'done' | null;
      videooh_media?: string | null;
      is_draft?: boolean;
      media_creative?: Array<{
        id?: number;
        media_id: number;
        mime_type?: string | null;
        name?: string | null;
        path?: string | null;
        created_at?: string | null;
      }>;
      format?: {
        id?: number;
        width: number;
        height: number;
        orientation?: 'vertical' | 'horizontal' | 'both' | null;
        text_slot?: number;
        allow_text?: boolean;
        allow_image?: boolean;
        allow_flash?: boolean;
        active?: boolean;
        stripped_name?: string | null;
        name?: string | null;
        order?: number | null;
        allow_as_media?: boolean;
        allow_publisher?: boolean;
        is_public?: boolean;
        extend_format_id?: number | null;
        native_template?: string | null;
        is_admin_dsp?: boolean;
      } | null;
      media_video?: Array<{
        id?: number;
        media_id: number;
        mime_type: string;
        file_path: string;
        duration?: number | null;
        width: number;
        height: number;
        bitrate?: number | null;
        filesize?: number | null;
        created_at?: string;
      }>;
    };
  }>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign/{id}/media/list',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns campaign positioning
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCampaignPositioning(
    id: number,
  ): CancelablePromise<Array<{
    id: number;
    zone_id: number;
    campaign_id: number;
    approval_status_id: 'active' | 'inactive' | 'optimized' | 'cancelled' | 'refused';
    views: number;
    clicks: number;
    viewed_impressions: number;
    refreshed_impressions: number;
    undetermined_impressions: number;
    cpm_rate: number | null;
    revenue_per_view: number;
    created_at: string | null;
    cpc_rate: number | null;
    revenue_per_click: number;
    mobilized_views: number;
    traffic_ratio: number;
    geo_ratio: number;
    vcpm_rate: number | null;
    zone?: {
      label: string | null;
      site: {
        id: number;
        name: string;
      } | null;
    };
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/campaign/{id}/positioning',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that returns campaign postal codes
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCampaignPostalCodeList(
    id: number,
  ): CancelablePromise<Array<{
    id: number;
    campaign_id: number;
    postal_code: string;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/campaign/{id}/postal_code/list',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that mass update all campaign postal codes
   * @param id
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaignPostalCodeList(
    id: number,
    requestBody?: Array<{
      id?: number;
      campaign_id: number;
      postal_code: string;
    }>,
  ): CancelablePromise<Array<{
    id: number;
    campaign_id: number;
    postal_code: string;
  }>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign/{id}/postal_code/list',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns a list of campaigns retargeting for a particular campaign
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCampaignRetargetingCampaignList(
    id: number,
  ): CancelablePromise<Array<{
    id: number;
    campaign_id: number;
    target_campaign_id: number;
    is_inclusive: boolean;
    status_id: 'active' | 'inactive';
    created_at: string;
    name?: string;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/campaign/{id}/retargeting/campaign/list',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that puts a campaign in review mode
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiCampaignReview(
    id: number,
  ): CancelablePromise<{
    id: number;
    type: 'Default' | 'Deal' | 'RTB';
    inventory_type_id: 'display' | 'video' | 'dooh' | 'ctv';
    delivery_model: 'cpm' | 'cpc' | 'flat' | 'cpv' | 'vcpm';
    targeting_level_id: 'ron' | 'roc' | 'ros' | null;
    language_id: string | null;
    platform_id: number;
    rate: number | null;
    budget: number | null;
    max_daily_spend: number | null;
    total_spend: number | null;
    bids: number | null;
    user_id: number | null;
    representative_id: number | null;
    advertiser_id: number | null;
    advertiser_domain_id: number | null;
    order_id: number | null;
    status_id: 'active' | 'cancelled' | 'expired' | 'pending' | 'planning' | 'pricing' | 'reservation' | 'review' | 'temporary';
    is_paused: boolean;
    content_type_id: number;
    priority_chain_id: 'low' | 'network' | 'channel' | 'permanent' | 'targeted' | 'rush';
    buyer_id: number | null;
    weight: number | null;
    paid: boolean;
    price: number | null;
    pricing_bundle_id: number | null;
    start_date: string | null;
    end_date: string | null;
    views: number;
    max_views: number | null;
    clicks: number;
    max_clicks: number | null;
    viewed_impressions: number;
    max_viewed_impressions: number | null;
    viewability_goal: number;
    override_viewability_optimization: boolean;
    refreshed_impressions: number;
    undetermined_impressions: number;
    quebec_sales_tax: number | null;
    goods_services_tax: number | null;
    net_price: number | null;
    product: string | null;
    client: string | null;
    contract_id: string | null;
    created_at: string;
    confirmed_at: string | null;
    media_notice_sent_days: number | null;
    billed_at: string | null;
    cap_premium: number | null;
    has_preferencial_rate: boolean;
    is_videoegg: boolean;
    is_monetized: boolean;
    notes: string | null;
    keywords: string | null;
    block_prioritizer: boolean;
    equalizing_filter: boolean;
    hours_filter: Array<number>;
    minutes_filter: Array<number>;
    weekdays_filter: Array<'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday'>;
    geo_filter: string | null;
    ip_filter: string | null;
    sequential_filter: boolean;
    min_celsius: number | null;
    max_celsius: number | null;
    auto_target: boolean;
    chain_active: boolean;
    is_rtb_active: boolean;
    is_rtb_fullscreen: boolean;
    is_bidding_only_on_deals: boolean;
    delivery_fee_active: boolean;
    blocks_auto_refresh: boolean;
    browser_language_filter: string | null;
    dooh_audience_age: number | null;
    dooh_audience_radius: number | null;
    dooh_audience_ratio: number | null;
    dooh_use_pompe_template: boolean;
    currency_id: string;
    cad_total_spend: number | null;
    ui_settings: any;
    updated_at: string;
    last_edited_at: string;
    description: string | null;
    order?: {
      agency_id?: number | null;
      name?: string | null;
      advertiser?: {
        name?: string;
      };
    } | null;
    campaign_user_tag: Array<{
      campaign_id: number;
      user_tag_id: number;
      user_tag?: {
        name: string;
      };
    }>;
  }> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/campaign/{id}/review',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that deletes a campaign schedule
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static deleteApiCampaignSchedule(
    id: number,
  ): CancelablePromise<{
    campaign_id: number;
    sunday: Array<number>;
    monday: Array<number>;
    tuesday: Array<number>;
    wednesday: Array<number>;
    thursday: Array<number>;
    friday: Array<number>;
    saturday: Array<number>;
  }> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/campaign/{id}/schedule',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that returns a campaign schedule
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCampaignSchedule(
    id: number,
  ): CancelablePromise<{
    campaign_id: number;
    sunday: Array<number>;
    monday: Array<number>;
    tuesday: Array<number>;
    wednesday: Array<number>;
    thursday: Array<number>;
    friday: Array<number>;
    saturday: Array<number>;
  } | null> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/campaign/{id}/schedule',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that returns campaign external segments
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCampaignSegmentExternalList(
    id: number,
  ): CancelablePromise<Array<{
    id: number;
    campaign_id: number;
    external_segment_id: number;
    is_inclusive: boolean;
    external_segment?: {
      id: number;
      dmp_id: number;
      agency_id: number;
      external_id: string;
      name: string;
      currency_id: string | null;
      cpm: number | null;
      ctv_cpm: number | null;
      description: string | null;
      dmp?: {
        id: number;
        name: string;
      };
    };
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/campaign/{id}/segment/external/list',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that mass update a campaign external segments
   * @param id
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaignSegmentExternalList(
    id: number,
    requestBody?: Array<{
      id?: number;
      campaign_id: number;
      external_segment_id: number;
      is_inclusive?: boolean;
    }>,
  ): CancelablePromise<Array<{
    id: number;
    campaign_id: number;
    external_segment_id: number;
    is_inclusive: boolean;
  }>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign/{id}/segment/external/list',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns all campaign ssp deals
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCampaignSspDealList(
    id: number,
  ): CancelablePromise<Array<{
    id: number;
    campaign_id: number;
    ssp_deal_id: number;
    status_id: 'active' | 'inactive';
    bids: number;
    impressions: number;
    clicks: number;
    ssp_id: number;
    dealid: string;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/campaign/{id}/ssp_deal/list',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that mass update a campaign ssp deals
   * @param id
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaignSspDealList(
    id: number,
    requestBody?: Array<{
      id?: number;
      campaign_id: number;
      ssp_deal_id: number;
      status_id?: 'active' | 'inactive';
      bids?: number;
      impressions?: number;
      clicks?: number;
    }>,
  ): CancelablePromise<Array<{
    id: number;
    campaign_id: number;
    ssp_deal_id: number;
    status_id: 'active' | 'inactive';
    bids: number;
    impressions: number;
    clicks: number;
    ssp_id: number;
    dealid: string;
  }>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign/{id}/ssp_deal/list',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns campaign ssp publishers
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCampaignSspPublisherList(
    id: number,
  ): CancelablePromise<Array<{
    id: number;
    campaign_id: number;
    ssp_publisher_id: number;
    ssp_publisher: {
      id?: number;
      ssp_id: number;
      publisher_name: string;
      publisher_url: string;
      default_deal_id?: number | null;
      is_deleted?: boolean;
    };
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/campaign/{id}/ssp_publisher/list',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that mass update all campaign ssp publishers
   * @param id
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaignSspPublisherList(
    id: number,
    requestBody?: Array<{
      id?: number;
      campaign_id: number;
      ssp_publisher_id: number;
    }>,
  ): CancelablePromise<Array<{
    id: number;
    campaign_id: number;
    ssp_publisher_id: number;
    ssp_publisher: {
      id?: number;
      ssp_id: number;
      publisher_name: string;
      publisher_url: string;
      default_deal_id?: number | null;
      is_deleted?: boolean;
    };
  }>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign/{id}/ssp_publisher/list',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns all campaign ssps
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCampaignSspList(
    id: number,
  ): CancelablePromise<Array<{
    id: number;
    campaign_id: number;
    ssp_id: number;
    ssp?: {
      id: number;
      name: string;
    };
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/campaign/{id}/ssp/list',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that mass update a campaign SSPs
   * @param id
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaignSspList(
    id: number,
    requestBody?: Array<{
      id?: number;
      campaign_id: number;
      ssp_id: number;
    }>,
  ): CancelablePromise<Array<{
    id: number;
    campaign_id: number;
    ssp_id: number;
    ssp?: {
      id: number;
      name: string;
    };
  }>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign/{id}/ssp/list',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns states shapes associated to a campaign
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCampaignStateShapeList(
    id: number,
  ): CancelablePromise<Array<{
    id: number;
    campaign_id: number;
    created_at: string;
    is_active: boolean;
    is_deleted: boolean;
    country_id: string;
    state_id: string;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/campaign/{id}/state_shape/list',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that mass update a campaign state shapes
   * @param id
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaignStateShapeList(
    id: number,
    requestBody?: Array<{
      id?: number;
      campaign_id: number;
      created_at?: string;
      is_active?: boolean;
      is_deleted?: boolean;
      country_id: string;
      state_id: string;
    }>,
  ): CancelablePromise<Array<{
    id: number;
    campaign_id: number;
    created_at: string;
    is_active: boolean;
    is_deleted: boolean;
    country_id: string;
    state_id: string;
  }>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign/{id}/state_shape/list',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns campaign user tags
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCampaignUsertagList(
    id: number,
  ): CancelablePromise<Array<{
    campaign_id: number;
    user_tag_id: number;
    user_tag: {
      name: string;
    };
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/campaign/{id}/usertag/list',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that returns campaign venue types
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCampaignVenuetypeList(
    id: number,
  ): CancelablePromise<Array<{
    id: number;
    campaign_id: number;
    venue_type_id: number;
    created_at: string;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/campaign/{id}/venuetype/list',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that mass update a campaign venue types
   * @param id
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaignVenuetypeList(
    id: number,
    requestBody?: Array<{
      id?: number;
      campaign_id: number;
      venue_type_id: number;
      created_at?: string;
    }>,
  ): CancelablePromise<Array<{
    id: number;
    campaign_id: number;
    venue_type_id: number;
    created_at: string;
  }>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign/{id}/venuetype/list',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns campaign weather
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCampaignWeatherList(
    id: number,
  ): CancelablePromise<Array<{
    id: number;
    campaign_id: number;
    weather_id: 'thunderstorm' | 'drizzle' | 'rain' | 'snow' | 'atmosphere' | 'clear' | 'clouds';
    created_at: string;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/campaign/{id}/weather/list',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that mass update a campaign weathers
   * @param id
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaignWeatherList(
    id: number,
    requestBody?: Array<{
      id?: number;
      campaign_id: number;
      weather_id: 'thunderstorm' | 'drizzle' | 'rain' | 'snow' | 'atmosphere' | 'clear' | 'clouds';
      created_at?: string;
    }>,
  ): CancelablePromise<Array<{
    id: number;
    campaign_id: number;
    weather_id: 'thunderstorm' | 'drizzle' | 'rain' | 'snow' | 'atmosphere' | 'clear' | 'clouds';
    created_at: string;
  }>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign/{id}/weather/list',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that deletes a campaign auction type
   * @param id1
   * @param id2
   * @returns any Default Response
   * @throws ApiError
   */
  public static deleteApiCampaignAuctionType(
    id1: number,
    id2: number,
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    auction_type_id: number;
    created_at: string;
  }> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/campaign/{id1}/auction/type/{id2}',
      path: {
        'id1': id1,
        'id2': id2,
      },
    });
  }

  /**
   * Method that deletes a campaign audience
   * @param id1
   * @param id2
   * @returns any Default Response
   * @throws ApiError
   */
  public static deleteApiCampaignAudience(
    id1: number,
    id2: number,
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    zone_id: number | null;
    tag_id: number | null;
    approval_status_id: 'active' | 'inactive';
    is_inclusive: boolean;
    created_at: string | null;
  }> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/campaign/{id1}/audience/{id2}',
      path: {
        'id1': id1,
        'id2': id2,
      },
    });
  }

  /**
   * Method that deletes a campaign area
   * @param id1
   * @param id2
   * @returns any Default Response
   * @throws ApiError
   */
  public static deleteApiCampaignAudienceArea(
    id1: number,
    id2: number,
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    audience_area_id: number;
    is_inclusive: boolean;
    status_id: 'active' | 'inactive';
    created_at: string;
  }> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/campaign/{id1}/audience/area/{id2}',
      path: {
        'id1': id1,
        'id2': id2,
      },
    });
  }

  /**
   * Method that deletes a campaign cap
   * @param id1
   * @param id2
   * @returns any Default Response
   * @throws ApiError
   */
  public static deleteApiCampaignCap(
    id1: number,
    id2: number,
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    frequency: number;
    units: number;
    period: 'second' | 'minute' | 'quarter' | 'hour' | 'day' | 'week' | 'month' | 'campaign';
  }> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/campaign/{id1}/cap/{id2}',
      path: {
        'id1': id1,
        'id2': id2,
      },
    });
  }

  /**
   * Method that deletes a campaign city association
   * @param id1
   * @param id2
   * @returns any Default Response
   * @throws ApiError
   */
  public static deleteApiCampaignCityShape(
    id1: number,
    id2: number,
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    created_at: string;
    is_active: boolean;
    is_deleted: boolean;
    city_shape_id: number;
  }> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/campaign/{id1}/city_shape/{id2}',
      path: {
        'id1': id1,
        'id2': id2,
      },
    });
  }

  /**
   * Method that deletes a campaign coordinate
   * @param id1
   * @param id2
   * @returns any Default Response
   * @throws ApiError
   */
  public static deleteApiCampaignCoordinate(
    id1: number,
    id2: number,
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    name: string;
    radius: number;
    latitude: number;
    longitude: number;
    created_at: string | null;
    updated_at: string | null;
    is_deleted: boolean;
  }> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/campaign/{id1}/coordinate/{id2}',
      path: {
        'id1': id1,
        'id2': id2,
      },
    });
  }

  /**
   * Method that deletes a campaign country association
   * @param id1
   * @param id2
   * @returns any Default Response
   * @throws ApiError
   */
  public static deleteApiCampaignCountryShape(
    id1: number,
    id2: number,
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    created_at: string;
    is_active: boolean;
    is_deleted: boolean;
    country_id: string;
  }> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/campaign/{id1}/country_shape/{id2}',
      path: {
        'id1': id1,
        'id2': id2,
      },
    });
  }

  /**
   * Method that deletes all campaign geography (needs to be called before create)
   * @param id1
   * @param id2
   * @returns any Default Response
   * @throws ApiError
   */
  public static deleteApiCampaignGeography(
    id1: number,
    id2: number,
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    country_id: string | null;
    state_id: string | null;
    city_id: number | null;
  }> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/campaign/{id1}/geography/{id2}',
      path: {
        'id1': id1,
        'id2': id2,
      },
    });
  }

  /**
   * Method that deletes a campaign media fee
   * @param id1
   * @param id2
   * @returns any Default Response
   * @throws ApiError
   */
  public static deleteApiCampaignMediaFee(
    id1: number,
    id2: number,
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    description: string;
    amount: number;
    type: string;
  }> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/campaign/{id1}/media_fee/{id2}',
      path: {
        'id1': id1,
        'id2': id2,
      },
    });
  }

  /**
   * Method that deletes a campaign media
   * @param id1
   * @param id2
   * @returns any Default Response
   * @throws ApiError
   */
  public static deleteApiCampaignMedia(
    id1: number,
    id2: number,
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    media_id: number;
    parent_campaign_media_id: number | null;
    is_companion: boolean;
    approval_status_id: 'active' | 'inactive' | 'pending' | 'refused';
    views: number;
    clicks: number;
    viewed_impressions: number;
    refreshed_impressions: number;
    undetermined_impressions: number;
    created_at: string;
    zone_id: number | null;
    clickthrough_url: string | null;
    start_date: string | null;
    end_date: string | null;
    max_impressions_ratio: number;
    is_video_playing_out_of_view: boolean;
    is_video_looping: boolean;
    inline_pause_to_overlay: boolean;
    refusal_notes: string | null;
    media?: {
      id?: number;
      name?: string | null;
      content_type_id: number;
      media_type_id: number;
      format_id?: number | null;
      mime_type?: string | null;
      preview_image_path?: string | null;
      media?: string | null;
      headline?: string | null;
      display_url?: string | null;
      duration?: number | null;
      created_at?: string | null;
      is_replacement?: boolean;
      is_deleted?: boolean;
      is_secure?: boolean;
      owner_id?: number | null;
      agency_id?: number | null;
      platform_id?: number;
      filesize?: number | null;
      height?: number | null;
      width?: number | null;
      videooh_encoding_status?: 'encoding' | 'error' | 'done' | null;
      videooh_media?: string | null;
      is_draft?: boolean;
      media_creative?: Array<{
        id?: number;
        media_id: number;
        mime_type?: string | null;
        name?: string | null;
        path?: string | null;
        created_at?: string | null;
      }>;
      format?: {
        id?: number;
        width: number;
        height: number;
        orientation?: 'vertical' | 'horizontal' | 'both' | null;
        text_slot?: number;
        allow_text?: boolean;
        allow_image?: boolean;
        allow_flash?: boolean;
        active?: boolean;
        stripped_name?: string | null;
        name?: string | null;
        order?: number | null;
        allow_as_media?: boolean;
        allow_publisher?: boolean;
        is_public?: boolean;
        extend_format_id?: number | null;
        native_template?: string | null;
        is_admin_dsp?: boolean;
      } | null;
      media_video?: Array<{
        id?: number;
        media_id: number;
        mime_type: string;
        file_path: string;
        duration?: number | null;
        width: number;
        height: number;
        bitrate?: number | null;
        filesize?: number | null;
        created_at?: string;
      }>;
    };
  }> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/campaign/{id1}/media/{id2}',
      path: {
        'id1': id1,
        'id2': id2,
      },
    });
  }

  /**
   * Method that get a specific campaign media
   * @param id1
   * @param id2
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCampaignMedia(
    id1: number,
    id2: number,
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    media_id: number;
    parent_campaign_media_id: number | null;
    is_companion: boolean;
    approval_status_id: 'active' | 'inactive' | 'pending' | 'refused';
    views: number;
    clicks: number;
    viewed_impressions: number;
    refreshed_impressions: number;
    undetermined_impressions: number;
    created_at: string;
    zone_id: number | null;
    clickthrough_url: string | null;
    start_date: string | null;
    end_date: string | null;
    max_impressions_ratio: number;
    is_video_playing_out_of_view: boolean;
    is_video_looping: boolean;
    inline_pause_to_overlay: boolean;
    refusal_notes: string | null;
    media?: {
      id?: number;
      name?: string | null;
      content_type_id: number;
      media_type_id: number;
      format_id?: number | null;
      mime_type?: string | null;
      preview_image_path?: string | null;
      media?: string | null;
      headline?: string | null;
      display_url?: string | null;
      duration?: number | null;
      created_at?: string | null;
      is_replacement?: boolean;
      is_deleted?: boolean;
      is_secure?: boolean;
      owner_id?: number | null;
      agency_id?: number | null;
      platform_id?: number;
      filesize?: number | null;
      height?: number | null;
      width?: number | null;
      videooh_encoding_status?: 'encoding' | 'error' | 'done' | null;
      videooh_media?: string | null;
      is_draft?: boolean;
      media_creative?: Array<{
        id?: number;
        media_id: number;
        mime_type?: string | null;
        name?: string | null;
        path?: string | null;
        created_at?: string | null;
      }>;
      format?: {
        id?: number;
        width: number;
        height: number;
        orientation?: 'vertical' | 'horizontal' | 'both' | null;
        text_slot?: number;
        allow_text?: boolean;
        allow_image?: boolean;
        allow_flash?: boolean;
        active?: boolean;
        stripped_name?: string | null;
        name?: string | null;
        order?: number | null;
        allow_as_media?: boolean;
        allow_publisher?: boolean;
        is_public?: boolean;
        extend_format_id?: number | null;
        native_template?: string | null;
        is_admin_dsp?: boolean;
      } | null;
      media_video?: Array<{
        id?: number;
        media_id: number;
        mime_type: string;
        file_path: string;
        duration?: number | null;
        width: number;
        height: number;
        bitrate?: number | null;
        filesize?: number | null;
        created_at?: string;
      }>;
    };
  } | null> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/campaign/{id1}/media/{id2}',
      path: {
        'id1': id1,
        'id2': id2,
      },
    });
  }

  /**
   * Method that merge a campaign into another campaign
   * @param id1
   * @param id2
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiCampaignMerge(
    id1: number,
    id2: number,
    requestBody?: {
      last_edited_at?: string;
    },
  ): CancelablePromise<{
    id: number;
    type: 'Default' | 'Deal' | 'RTB';
    inventory_type_id: 'display' | 'video' | 'dooh' | 'ctv';
    delivery_model: 'cpm' | 'cpc' | 'flat' | 'cpv' | 'vcpm';
    targeting_level_id: 'ron' | 'roc' | 'ros' | null;
    language_id: string | null;
    platform_id: number;
    rate: number | null;
    budget: number | null;
    max_daily_spend: number | null;
    total_spend: number | null;
    bids: number | null;
    user_id: number | null;
    representative_id: number | null;
    advertiser_id: number | null;
    advertiser_domain_id: number | null;
    order_id: number | null;
    status_id: 'active' | 'cancelled' | 'expired' | 'pending' | 'planning' | 'pricing' | 'reservation' | 'review' | 'temporary';
    is_paused: boolean;
    content_type_id: number;
    priority_chain_id: 'low' | 'network' | 'channel' | 'permanent' | 'targeted' | 'rush';
    buyer_id: number | null;
    weight: number | null;
    paid: boolean;
    price: number | null;
    pricing_bundle_id: number | null;
    start_date: string | null;
    end_date: string | null;
    views: number;
    max_views: number | null;
    clicks: number;
    max_clicks: number | null;
    viewed_impressions: number;
    max_viewed_impressions: number | null;
    viewability_goal: number;
    override_viewability_optimization: boolean;
    refreshed_impressions: number;
    undetermined_impressions: number;
    quebec_sales_tax: number | null;
    goods_services_tax: number | null;
    net_price: number | null;
    product: string | null;
    client: string | null;
    contract_id: string | null;
    created_at: string;
    confirmed_at: string | null;
    media_notice_sent_days: number | null;
    billed_at: string | null;
    cap_premium: number | null;
    has_preferencial_rate: boolean;
    is_videoegg: boolean;
    is_monetized: boolean;
    notes: string | null;
    keywords: string | null;
    block_prioritizer: boolean;
    equalizing_filter: boolean;
    hours_filter: Array<number>;
    minutes_filter: Array<number>;
    weekdays_filter: Array<'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday'>;
    geo_filter: string | null;
    ip_filter: string | null;
    sequential_filter: boolean;
    min_celsius: number | null;
    max_celsius: number | null;
    auto_target: boolean;
    chain_active: boolean;
    is_rtb_active: boolean;
    is_rtb_fullscreen: boolean;
    is_bidding_only_on_deals: boolean;
    delivery_fee_active: boolean;
    blocks_auto_refresh: boolean;
    browser_language_filter: string | null;
    dooh_audience_age: number | null;
    dooh_audience_radius: number | null;
    dooh_audience_ratio: number | null;
    dooh_use_pompe_template: boolean;
    currency_id: string;
    cad_total_spend: number | null;
    ui_settings: any;
    updated_at: string;
    last_edited_at: string;
    description: string | null;
    order?: {
      agency_id?: number | null;
      name?: string | null;
      advertiser?: {
        name?: string;
      };
    } | null;
    campaign_user_tag: Array<{
      campaign_id: number;
      user_tag_id: number;
      user_tag?: {
        name: string;
      };
    }>;
  }> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/campaign/{id1}/merge/{id2}',
      path: {
        'id1': id1,
        'id2': id2,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that deletes a campaign postal code
   * @param id1
   * @param id2
   * @returns any Default Response
   * @throws ApiError
   */
  public static deleteApiCampaignPostalCode(
    id1: number,
    id2: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/campaign/{id1}/postal_code/{id2}',
      path: {
        'id1': id1,
        'id2': id2,
      },
    });
  }

  /**
   * Method that deletes a campaign external segment
   * @param id1
   * @param id2
   * @returns any Default Response
   * @throws ApiError
   */
  public static deleteApiCampaignSegmentExternal(
    id1: number,
    id2: number,
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    external_segment_id: number;
    is_inclusive: boolean;
  }> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/campaign/{id1}/segment/external/{id2}',
      path: {
        'id1': id1,
        'id2': id2,
      },
    });
  }

  /**
   * Method that deletes a campaign ssp deal
   * @param id1
   * @param id2
   * @returns any Default Response
   * @throws ApiError
   */
  public static deleteApiCampaignSspDeal(
    id1: number,
    id2: number,
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    ssp_deal_id: number;
    status_id: 'active' | 'inactive';
    bids: number;
    impressions: number;
    clicks: number;
  }> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/campaign/{id1}/ssp_deal/{id2}',
      path: {
        'id1': id1,
        'id2': id2,
      },
    });
  }

  /**
   * Method that returns a particular campaign ssp deal
   * @param id1
   * @param id2
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCampaignSspDeal(
    id1: number,
    id2: number,
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    ssp_deal_id: number;
    status_id: 'active' | 'inactive';
    bids: number;
    impressions: number;
    clicks: number;
    ssp_id: number;
    dealid: string;
  } | null> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/campaign/{id1}/ssp_deal/{id2}',
      path: {
        'id1': id1,
        'id2': id2,
      },
    });
  }

  /**
   * Method that deletes a campaign ssp publisher
   * @param id1
   * @param id2
   * @returns any Default Response
   * @throws ApiError
   */
  public static deleteApiCampaignSspPublisher(
    id1: number,
    id2: number,
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    ssp_publisher_id: number;
    ssp_publisher: {
      id?: number;
      ssp_id: number;
      publisher_name: string;
      publisher_url: string;
      default_deal_id?: number | null;
      is_deleted?: boolean;
    };
  }> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/campaign/{id1}/ssp_publisher/{id2}',
      path: {
        'id1': id1,
        'id2': id2,
      },
    });
  }

  /**
   * Method that returns a particular campaign ssp publisher
   * @param id1
   * @param id2
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCampaignSspPublisher(
    id1: number,
    id2: number,
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    ssp_publisher_id: number;
    ssp_publisher: {
      id?: number;
      ssp_id: number;
      publisher_name: string;
      publisher_url: string;
      default_deal_id?: number | null;
      is_deleted?: boolean;
    };
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/campaign/{id1}/ssp_publisher/{id2}',
      path: {
        'id1': id1,
        'id2': id2,
      },
    });
  }

  /**
   * Method that deletes a campaign ssp
   * @param id1
   * @param id2
   * @returns any Default Response
   * @throws ApiError
   */
  public static deleteApiCampaignSsp(
    id1: number,
    id2: number,
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    ssp_id: number;
    ssp?: {
      id: number;
      name: string;
    };
  }> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/campaign/{id1}/ssp/{id2}',
      path: {
        'id1': id1,
        'id2': id2,
      },
    });
  }

  /**
   * Method that returns a particular campaign ssp
   * @param id1
   * @param id2
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCampaignSsp(
    id1: number,
    id2: number,
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    ssp_id: number;
    ssp?: {
      id: number;
      name: string;
    };
  } | null> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/campaign/{id1}/ssp/{id2}',
      path: {
        'id1': id1,
        'id2': id2,
      },
    });
  }

  /**
   * Method that deletes a campaign state association
   * @param id1
   * @param id2
   * @returns any Default Response
   * @throws ApiError
   */
  public static deleteApiCampaignStateShape(
    id1: number,
    id2: number,
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    created_at: string;
    is_active: boolean;
    is_deleted: boolean;
    country_id: string;
    state_id: string;
  }> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/campaign/{id1}/state_shape/{id2}',
      path: {
        'id1': id1,
        'id2': id2,
      },
    });
  }

  /**
   * Method that deletes a particular user tag for a campaign
   * @param id1
   * @param id2
   * @returns any Default Response
   * @throws ApiError
   */
  public static deleteApiCampaignUsertag(
    id1: number,
    id2: number,
  ): CancelablePromise<{
    campaign_id: number;
    user_tag_id: number;
    user_tag: {
      name: string;
    };
  }> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/campaign/{id1}/usertag/{id2}',
      path: {
        'id1': id1,
        'id2': id2,
      },
    });
  }

  /**
   * Method that deletes a campaign venue type
   * @param id1
   * @param id2
   * @returns any Default Response
   * @throws ApiError
   */
  public static deleteApiCampaignVenuetype(
    id1: number,
    id2: number,
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    venue_type_id: number;
    created_at: string;
  }> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/campaign/{id1}/venuetype/{id2}',
      path: {
        'id1': id1,
        'id2': id2,
      },
    });
  }

  /**
   * Method that deletes a campaign weather
   * @param id1
   * @param id2
   * @returns any Default Response
   * @throws ApiError
   */
  public static deleteApiCampaignWeather(
    id1: number,
    id2: number,
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    weather_id: 'thunderstorm' | 'drizzle' | 'rain' | 'snow' | 'atmosphere' | 'clear' | 'clouds';
    created_at: string;
  }> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/campaign/{id1}/weather/{id2}',
      path: {
        'id1': id1,
        'id2': id2,
      },
    });
  }

  /**
   * Method that creates a campaign auction type
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaignAuctionType(
    requestBody: {
      id?: number;
      campaign_id: number;
      auction_type_id: number;
      created_at?: string;
    },
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    auction_type_id: number;
    created_at: string;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign/auction/type',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that creates a campaign audience
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaignAudience(
    requestBody: {
      id?: number;
      campaign_id: number;
      zone_id?: number | null;
      tag_id?: number | null;
      approval_status_id?: 'active' | 'inactive';
      is_inclusive?: boolean;
      created_at?: string | null;
    },
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    zone_id: number | null;
    tag_id: number | null;
    approval_status_id: 'active' | 'inactive';
    is_inclusive: boolean;
    created_at: string | null;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign/audience',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that updates a campaign audience
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiCampaignAudience(
    requestBody: {
      id: number;
      campaign_id: number;
      zone_id?: number | null;
      tag_id?: number | null;
      approval_status_id?: 'active' | 'inactive';
      is_inclusive?: boolean;
      created_at?: string | null;
    },
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    zone_id: number | null;
    tag_id: number | null;
    approval_status_id: 'active' | 'inactive';
    is_inclusive: boolean;
    created_at: string | null;
  }> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/campaign/audience',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that creates a campaign area
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaignAudienceArea(
    requestBody: {
      id?: number;
      campaign_id: number;
      audience_area_id: number;
      is_inclusive?: boolean;
      status_id?: 'active' | 'inactive';
      created_at?: string;
    },
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    audience_area_id: number;
    is_inclusive: boolean;
    status_id: 'active' | 'inactive';
    created_at: string;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign/audience/area',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that updates a campaign area
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiCampaignAudienceArea(
    requestBody: {
      id: number;
      campaign_id: number;
      audience_area_id?: number;
      is_inclusive?: boolean;
      status_id?: 'active' | 'inactive';
      created_at?: string;
    },
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    audience_area_id: number;
    is_inclusive: boolean;
    status_id: 'active' | 'inactive';
    created_at: string;
  }> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/campaign/audience/area',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that creates a campaign cap
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaignCap(
    requestBody: {
      id?: number;
      campaign_id: number;
      frequency: number;
      units?: number;
      period: 'second' | 'minute' | 'quarter' | 'hour' | 'day' | 'week' | 'month' | 'campaign';
    },
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    frequency: number;
    units: number;
    period: 'second' | 'minute' | 'quarter' | 'hour' | 'day' | 'week' | 'month' | 'campaign';
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign/cap',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that updates a campaign cap
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiCampaignCap(
    requestBody: {
      id: number;
      campaign_id: number;
      frequency?: number;
      units?: number;
      period?: 'second' | 'minute' | 'quarter' | 'hour' | 'day' | 'week' | 'month' | 'campaign';
    },
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    frequency: number;
    units: number;
    period: 'second' | 'minute' | 'quarter' | 'hour' | 'day' | 'week' | 'month' | 'campaign';
  }> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/campaign/cap',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns possible campaign caps
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCampaignCapList1(): CancelablePromise<Array<{
    id: string;
    name: string;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/campaign/cap/list',
    });
  }

  /**
   * Method that creates a campaign city shape association
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaignCityShape(
    requestBody: {
      id?: number;
      campaign_id: number;
      created_at?: string;
      is_active?: boolean;
      is_deleted?: boolean;
      city_shape_id: number;
    },
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    created_at: string;
    is_active: boolean;
    is_deleted: boolean;
    city_shape_id: number;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign/city_shape',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that updates a campaign city association is_active flag
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiCampaignCityShape(
    requestBody: {
      id: number;
      campaign_id: number;
      created_at?: string;
      is_active?: boolean;
      is_deleted?: boolean;
      city_shape_id?: number;
    },
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    created_at: string;
    is_active: boolean;
    is_deleted: boolean;
    city_shape_id: number;
  }> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/campaign/city_shape',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that creates a campaign coordinate
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaignCoordinate(
    requestBody: {
      id?: number;
      campaign_id: number;
      name?: string;
      radius: number;
      latitude?: number;
      longitude?: number;
      created_at?: string | null;
      updated_at?: string | null;
      is_deleted?: boolean;
    },
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    name: string;
    radius: number;
    latitude: number;
    longitude: number;
    created_at: string | null;
    updated_at: string | null;
    is_deleted: boolean;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign/coordinate',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that updates a campaign coordinate
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiCampaignCoordinate(
    requestBody: {
      id: number;
      campaign_id: number;
      name?: string;
      radius?: number;
      latitude?: number;
      longitude?: number;
      created_at?: string | null;
      updated_at?: string | null;
      is_deleted?: boolean;
    },
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    name: string;
    radius: number;
    latitude: number;
    longitude: number;
    created_at: string | null;
    updated_at: string | null;
    is_deleted: boolean;
  }> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/campaign/coordinate',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns a list of campaigns
   * @param offset
   * @param limit
   * @param search
   * @param match
   * @param orderby
   * @param comparator
   * @param id
   * @param statusId
   * @param inventoryTypeId
   * @param type
   * @param targetingLevelId
   * @param priorityChainId
   * @param orderId
   * @param startDate
   * @param endDate
   * @param lastEditedAt
   * @param createdAt
   * @param isMonetized
   * @param isPending
   * @param languageId
   * @param userId role operator only
   * @param accountManagerId role operator and account.agencies
   * @param advertiser
   * @param views
   * @param totalSpend
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCampaignCount(
    offset?: number,
    limit?: number,
    search?: string,
    match: 'exact' | 'contains' | 'starts_with' | 'ends_with' | 'not' = 'starts_with',
    orderby?: Array<string>,
    comparator?: Array<string>,
    id?: Array<number>,
    statusId?: Array<'active' | 'cancelled' | 'expired' | 'pending' | 'planning' | 'pricing' | 'reservation' | 'review' | 'temporary'>,
    inventoryTypeId?: 'display' | 'video' | 'dooh' | 'ctv',
    type?: 'Default' | 'Deal' | 'RTB',
    targetingLevelId?: 'ron' | 'roc' | 'ros',
    priorityChainId?: 'low' | 'network' | 'channel' | 'permanent' | 'targeted' | 'rush',
    orderId?: Array<number | null>,
    startDate?: Array<string | null>,
    endDate?: Array<string | null>,
    lastEditedAt?: Array<string>,
    createdAt?: Array<string>,
    isMonetized?: boolean,
    isPending?: boolean,
    languageId?: 'de' | 'el' | 'en' | 'es' | 'fr' | 'it' | 'ja' | 'pt' | 'zh',
    userId?: number | null,
    accountManagerId?: number,
    advertiser?: Array<number>,
    views?: number,
    totalSpend?: number | null,
  ): CancelablePromise<{
    count: number;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/campaign/count',
      query: {
        'offset': offset,
        'limit': limit,
        'search': search,
        'match': match,
        'orderby': orderby,
        'comparator': comparator,
        'id': id,
        'status_id': statusId,
        'inventory_type_id': inventoryTypeId,
        'type': type,
        'targeting_level_id': targetingLevelId,
        'priority_chain_id': priorityChainId,
        'order_id': orderId,
        'start_date': startDate,
        'end_date': endDate,
        'last_edited_at': lastEditedAt,
        'created_at': createdAt,
        'is_monetized': isMonetized,
        'is_pending': isPending,
        'language_id': languageId,
        'user_id': userId,
        'account_manager_id': accountManagerId,
        'advertiser': advertiser,
        'views': views,
        'total_spend': totalSpend,
      },
    });
  }

  /**
   * Method that creates a campaign country shape association
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaignCountryShape(
    requestBody: {
      id?: number;
      campaign_id: number;
      created_at?: string;
      is_active?: boolean;
      is_deleted?: boolean;
      country_id: string;
    },
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    created_at: string;
    is_active: boolean;
    is_deleted: boolean;
    country_id: string;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign/country_shape',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that updates a campaign country association is_active flag
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiCampaignCountryShape(
    requestBody: {
      id: number;
      campaign_id: number;
      created_at?: string;
      is_active?: boolean;
      is_deleted?: boolean;
      country_id?: string;
    },
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    created_at: string;
    is_active: boolean;
    is_deleted: boolean;
    country_id: string;
  }> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/campaign/country_shape',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that creates a campaign geography (country/state/city)
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaignGeography(
    requestBody: {
      id?: number;
      campaign_id: number;
      country_id?: string | null;
      state_id?: string | null;
      city_id?: number | null;
    },
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    country_id: string | null;
    state_id: string | null;
    city_id: number | null;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign/geography',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns a list of campaigns
   * @param offset
   * @param limit
   * @param search
   * @param match
   * @param orderby
   * @param comparator
   * @param id
   * @param statusId
   * @param inventoryTypeId
   * @param type
   * @param targetingLevelId
   * @param priorityChainId
   * @param orderId
   * @param startDate
   * @param endDate
   * @param lastEditedAt
   * @param createdAt
   * @param isMonetized
   * @param isPending
   * @param languageId
   * @param userId role operator only
   * @param accountManagerId role operator and account.agencies
   * @param advertiser
   * @param views
   * @param totalSpend
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCampaignList(
    offset?: number,
    limit?: number,
    search?: string,
    match: 'exact' | 'contains' | 'starts_with' | 'ends_with' | 'not' = 'starts_with',
    orderby?: Array<string>,
    comparator?: Array<string>,
    id?: Array<number>,
    statusId?: Array<'active' | 'cancelled' | 'expired' | 'pending' | 'planning' | 'pricing' | 'reservation' | 'review' | 'temporary'>,
    inventoryTypeId?: 'display' | 'video' | 'dooh' | 'ctv',
    type?: 'Default' | 'Deal' | 'RTB',
    targetingLevelId?: 'ron' | 'roc' | 'ros',
    priorityChainId?: 'low' | 'network' | 'channel' | 'permanent' | 'targeted' | 'rush',
    orderId?: Array<number | null>,
    startDate?: Array<string | null>,
    endDate?: Array<string | null>,
    lastEditedAt?: Array<string>,
    createdAt?: Array<string>,
    isMonetized?: boolean,
    isPending?: boolean,
    languageId?: 'de' | 'el' | 'en' | 'es' | 'fr' | 'it' | 'ja' | 'pt' | 'zh',
    userId?: number | null,
    accountManagerId?: number,
    advertiser?: Array<number>,
    views?: number,
    totalSpend?: number | null,
  ): CancelablePromise<Array<{
    id: number;
    type: 'Default' | 'Deal' | 'RTB';
    inventory_type_id: 'display' | 'video' | 'dooh' | 'ctv';
    delivery_model: 'cpm' | 'cpc' | 'flat' | 'cpv' | 'vcpm';
    targeting_level_id: 'ron' | 'roc' | 'ros' | null;
    language_id: string | null;
    platform_id: number;
    rate: number | null;
    budget: number | null;
    max_daily_spend: number | null;
    total_spend: number | null;
    bids: number | null;
    user_id: number | null;
    representative_id: number | null;
    advertiser_id: number | null;
    advertiser_domain_id: number | null;
    order_id: number | null;
    status_id: 'active' | 'cancelled' | 'expired' | 'pending' | 'planning' | 'pricing' | 'reservation' | 'review' | 'temporary';
    is_paused: boolean;
    content_type_id: number;
    priority_chain_id: 'low' | 'network' | 'channel' | 'permanent' | 'targeted' | 'rush';
    buyer_id: number | null;
    weight: number | null;
    paid: boolean;
    price: number | null;
    pricing_bundle_id: number | null;
    start_date: string | null;
    end_date: string | null;
    views: number;
    max_views: number | null;
    clicks: number;
    max_clicks: number | null;
    viewed_impressions: number;
    max_viewed_impressions: number | null;
    viewability_goal: number;
    override_viewability_optimization: boolean;
    refreshed_impressions: number;
    undetermined_impressions: number;
    quebec_sales_tax: number | null;
    goods_services_tax: number | null;
    net_price: number | null;
    product: string | null;
    client: string | null;
    contract_id: string | null;
    created_at: string;
    confirmed_at: string | null;
    media_notice_sent_days: number | null;
    billed_at: string | null;
    cap_premium: number | null;
    has_preferencial_rate: boolean;
    is_videoegg: boolean;
    is_monetized: boolean;
    notes: string | null;
    keywords: string | null;
    block_prioritizer: boolean;
    equalizing_filter: boolean;
    hours_filter: Array<number>;
    minutes_filter: Array<number>;
    weekdays_filter: Array<'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday'>;
    geo_filter: string | null;
    ip_filter: string | null;
    sequential_filter: boolean;
    min_celsius: number | null;
    max_celsius: number | null;
    auto_target: boolean;
    chain_active: boolean;
    is_rtb_active: boolean;
    is_rtb_fullscreen: boolean;
    is_bidding_only_on_deals: boolean;
    delivery_fee_active: boolean;
    blocks_auto_refresh: boolean;
    browser_language_filter: string | null;
    dooh_audience_age: number | null;
    dooh_audience_radius: number | null;
    dooh_audience_ratio: number | null;
    dooh_use_pompe_template: boolean;
    currency_id: string;
    cad_total_spend: number | null;
    ui_settings: any;
    updated_at: string;
    last_edited_at: string;
    description: string | null;
    order?: {
      agency_id?: number | null;
      name?: string | null;
      advertiser?: {
        name?: string;
      };
    } | null;
    campaign_user_tag: Array<{
      campaign_id: number;
      user_tag_id: number;
      user_tag?: {
        name: string;
      };
    }>;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/campaign/list',
      query: {
        'offset': offset,
        'limit': limit,
        'search': search,
        'match': match,
        'orderby': orderby,
        'comparator': comparator,
        'id': id,
        'status_id': statusId,
        'inventory_type_id': inventoryTypeId,
        'type': type,
        'targeting_level_id': targetingLevelId,
        'priority_chain_id': priorityChainId,
        'order_id': orderId,
        'start_date': startDate,
        'end_date': endDate,
        'last_edited_at': lastEditedAt,
        'created_at': createdAt,
        'is_monetized': isMonetized,
        'is_pending': isPending,
        'language_id': languageId,
        'user_id': userId,
        'account_manager_id': accountManagerId,
        'advertiser': advertiser,
        'views': views,
        'total_spend': totalSpend,
      },
    });
  }

  /**
   * Method that creates a campaign media fee
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaignMediaFee(
    requestBody: {
      id?: number;
      campaign_id: number;
      description: string;
      amount: number;
      type: string;
    },
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    description: string;
    amount: number;
    type: string;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign/media_fee',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that updates a campaign media fee
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiCampaignMediaFee(
    requestBody: {
      id: number;
      campaign_id: number;
      description?: string;
      amount?: number;
      type?: string;
    },
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    description: string;
    amount: number;
    type: string;
  }> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/campaign/media_fee',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that creates a campaign media
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaignMedia(
    requestBody: {
      id?: number;
      campaign_id: number;
      media_id: number;
      parent_campaign_media_id?: number | null;
      is_companion?: boolean;
      approval_status_id?: 'active' | 'inactive' | 'pending' | 'refused';
      views?: number;
      clicks?: number;
      viewed_impressions?: number;
      refreshed_impressions?: number;
      undetermined_impressions?: number;
      created_at?: string;
      zone_id?: number | null;
      clickthrough_url?: string | null;
      start_date?: string | null;
      end_date?: string | null;
      max_impressions_ratio?: number;
      is_video_playing_out_of_view?: boolean;
      is_video_looping?: boolean;
      inline_pause_to_overlay?: boolean;
      refusal_notes?: string | null;
    },
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    media_id: number;
    parent_campaign_media_id: number | null;
    is_companion: boolean;
    approval_status_id: 'active' | 'inactive' | 'pending' | 'refused';
    views: number;
    clicks: number;
    viewed_impressions: number;
    refreshed_impressions: number;
    undetermined_impressions: number;
    created_at: string;
    zone_id: number | null;
    clickthrough_url: string | null;
    start_date: string | null;
    end_date: string | null;
    max_impressions_ratio: number;
    is_video_playing_out_of_view: boolean;
    is_video_looping: boolean;
    inline_pause_to_overlay: boolean;
    refusal_notes: string | null;
    media?: {
      id?: number;
      name?: string | null;
      content_type_id: number;
      media_type_id: number;
      format_id?: number | null;
      mime_type?: string | null;
      preview_image_path?: string | null;
      media?: string | null;
      headline?: string | null;
      display_url?: string | null;
      duration?: number | null;
      created_at?: string | null;
      is_replacement?: boolean;
      is_deleted?: boolean;
      is_secure?: boolean;
      owner_id?: number | null;
      agency_id?: number | null;
      platform_id?: number;
      filesize?: number | null;
      height?: number | null;
      width?: number | null;
      videooh_encoding_status?: 'encoding' | 'error' | 'done' | null;
      videooh_media?: string | null;
      is_draft?: boolean;
      media_creative?: Array<{
        id?: number;
        media_id: number;
        mime_type?: string | null;
        name?: string | null;
        path?: string | null;
        created_at?: string | null;
      }>;
      format?: {
        id?: number;
        width: number;
        height: number;
        orientation?: 'vertical' | 'horizontal' | 'both' | null;
        text_slot?: number;
        allow_text?: boolean;
        allow_image?: boolean;
        allow_flash?: boolean;
        active?: boolean;
        stripped_name?: string | null;
        name?: string | null;
        order?: number | null;
        allow_as_media?: boolean;
        allow_publisher?: boolean;
        is_public?: boolean;
        extend_format_id?: number | null;
        native_template?: string | null;
        is_admin_dsp?: boolean;
      } | null;
      media_video?: Array<{
        id?: number;
        media_id: number;
        mime_type: string;
        file_path: string;
        duration?: number | null;
        width: number;
        height: number;
        bitrate?: number | null;
        filesize?: number | null;
        created_at?: string;
      }>;
    };
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign/media',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that updates a campaign media
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiCampaignMedia(
    requestBody: {
      id: number;
      campaign_id: number;
      media_id?: number;
      parent_campaign_media_id?: number | null;
      is_companion?: boolean;
      approval_status_id?: 'active' | 'inactive' | 'pending' | 'refused';
      views?: number;
      clicks?: number;
      viewed_impressions?: number;
      refreshed_impressions?: number;
      undetermined_impressions?: number;
      created_at?: string;
      zone_id?: number | null;
      clickthrough_url?: string | null;
      start_date?: string | null;
      end_date?: string | null;
      max_impressions_ratio?: number;
      is_video_playing_out_of_view?: boolean;
      is_video_looping?: boolean;
      inline_pause_to_overlay?: boolean;
      refusal_notes?: string | null;
    },
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    media_id: number;
    parent_campaign_media_id: number | null;
    is_companion: boolean;
    approval_status_id: 'active' | 'inactive' | 'pending' | 'refused';
    views: number;
    clicks: number;
    viewed_impressions: number;
    refreshed_impressions: number;
    undetermined_impressions: number;
    created_at: string;
    zone_id: number | null;
    clickthrough_url: string | null;
    start_date: string | null;
    end_date: string | null;
    max_impressions_ratio: number;
    is_video_playing_out_of_view: boolean;
    is_video_looping: boolean;
    inline_pause_to_overlay: boolean;
    refusal_notes: string | null;
    media?: {
      id?: number;
      name?: string | null;
      content_type_id: number;
      media_type_id: number;
      format_id?: number | null;
      mime_type?: string | null;
      preview_image_path?: string | null;
      media?: string | null;
      headline?: string | null;
      display_url?: string | null;
      duration?: number | null;
      created_at?: string | null;
      is_replacement?: boolean;
      is_deleted?: boolean;
      is_secure?: boolean;
      owner_id?: number | null;
      agency_id?: number | null;
      platform_id?: number;
      filesize?: number | null;
      height?: number | null;
      width?: number | null;
      videooh_encoding_status?: 'encoding' | 'error' | 'done' | null;
      videooh_media?: string | null;
      is_draft?: boolean;
      media_creative?: Array<{
        id?: number;
        media_id: number;
        mime_type?: string | null;
        name?: string | null;
        path?: string | null;
        created_at?: string | null;
      }>;
      format?: {
        id?: number;
        width: number;
        height: number;
        orientation?: 'vertical' | 'horizontal' | 'both' | null;
        text_slot?: number;
        allow_text?: boolean;
        allow_image?: boolean;
        allow_flash?: boolean;
        active?: boolean;
        stripped_name?: string | null;
        name?: string | null;
        order?: number | null;
        allow_as_media?: boolean;
        allow_publisher?: boolean;
        is_public?: boolean;
        extend_format_id?: number | null;
        native_template?: string | null;
        is_admin_dsp?: boolean;
      } | null;
      media_video?: Array<{
        id?: number;
        media_id: number;
        mime_type: string;
        file_path: string;
        duration?: number | null;
        width: number;
        height: number;
        bitrate?: number | null;
        filesize?: number | null;
        created_at?: string;
      }>;
    };
  }> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/campaign/media',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that creates campaign postal codes
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaignPostalCode(
    requestBody: {
      id?: number;
      campaign_id: number;
      postal_code: string;
    },
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign/postal_code',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that updates a campaign postal code
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiCampaignPostalCode(
    requestBody: {
      id: number;
      campaign_id: number;
      postal_code?: string;
    },
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/campaign/postal_code',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that creates a campaign schedule
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaignSchedule(
    requestBody: {
      campaign_id: number;
      sunday?: Array<number>;
      monday?: Array<number>;
      tuesday?: Array<number>;
      wednesday?: Array<number>;
      thursday?: Array<number>;
      friday?: Array<number>;
      saturday?: Array<number>;
    },
  ): CancelablePromise<{
    campaign_id: number;
    sunday: Array<number>;
    monday: Array<number>;
    tuesday: Array<number>;
    wednesday: Array<number>;
    thursday: Array<number>;
    friday: Array<number>;
    saturday: Array<number>;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign/schedule',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that updates a campaign schedule
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiCampaignSchedule(
    requestBody: {
      campaign_id: number;
      sunday?: Array<number>;
      monday?: Array<number>;
      tuesday?: Array<number>;
      wednesday?: Array<number>;
      thursday?: Array<number>;
      friday?: Array<number>;
      saturday?: Array<number>;
    },
  ): CancelablePromise<{
    campaign_id: number;
    sunday: Array<number>;
    monday: Array<number>;
    tuesday: Array<number>;
    wednesday: Array<number>;
    thursday: Array<number>;
    friday: Array<number>;
    saturday: Array<number>;
  }> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/campaign/schedule',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that creates a campaign external segment
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaignSegmentExternal(
    requestBody: {
      id?: number;
      campaign_id: number;
      external_segment_id: number;
      is_inclusive?: boolean;
    },
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    external_segment_id: number;
    is_inclusive: boolean;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign/segment/external',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that updates a campaign external segment
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiCampaignSegmentExternal(
    requestBody: {
      id: number;
      campaign_id: number;
      external_segment_id?: number;
      is_inclusive?: boolean;
    },
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    external_segment_id: number;
    is_inclusive: boolean;
  }> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/campaign/segment/external',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns possible segment filter types
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCampaignSegmentFilterTypeList(): CancelablePromise<Array<{
    id: string;
    name: string;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/campaign/segment/filter/type/list',
    });
  }

  /**
   * Method that creates a campaign ssp deal
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaignSspDeal(
    requestBody: {
      id?: number;
      campaign_id: number;
      ssp_deal_id: number;
      status_id?: 'active' | 'inactive';
      bids?: number;
      impressions?: number;
      clicks?: number;
    },
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    ssp_deal_id: number;
    status_id: 'active' | 'inactive';
    bids: number;
    impressions: number;
    clicks: number;
    ssp_id: number;
    dealid: string;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign/ssp_deal',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that creates campaign ssp publishers
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaignSspPublisher(
    requestBody: {
      id?: number;
      campaign_id: number;
      ssp_publisher_id: number;
    },
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    ssp_publisher_id: number;
    ssp_publisher: {
      id?: number;
      ssp_id: number;
      publisher_name: string;
      publisher_url: string;
      default_deal_id?: number | null;
      is_deleted?: boolean;
    };
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign/ssp_publisher',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that updates a campaign ssp publisher
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiCampaignSspPublisher(
    requestBody: {
      id: number;
      campaign_id: number;
      ssp_publisher_id?: number;
    },
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    ssp_publisher_id: number;
    ssp_publisher: {
      id?: number;
      ssp_id: number;
      publisher_name: string;
      publisher_url: string;
      default_deal_id?: number | null;
      is_deleted?: boolean;
    };
  }> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/campaign/ssp_publisher',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that creates a campaign ssp
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaignSsp(
    requestBody: {
      id?: number;
      campaign_id: number;
      ssp_id: number;
    },
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    ssp_id: number;
    ssp?: {
      id: number;
      name: string;
    };
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign/ssp',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that creates a campaign state shape association
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaignStateShape(
    requestBody: {
      id?: number;
      campaign_id: number;
      created_at?: string;
      is_active?: boolean;
      is_deleted?: boolean;
      country_id: string;
      state_id: string;
    },
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    created_at: string;
    is_active: boolean;
    is_deleted: boolean;
    country_id: string;
    state_id: string;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign/state_shape',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that updates a campaign state association is_active flag
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiCampaignStateShape(
    requestBody: {
      id: number;
      campaign_id: number;
      created_at?: string;
      is_active?: boolean;
      is_deleted?: boolean;
      country_id?: string;
      state_id?: string;
    },
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    created_at: string;
    is_active: boolean;
    is_deleted: boolean;
    country_id: string;
    state_id: string;
  }> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/campaign/state_shape',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns possible campaign status
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCampaignStatusList(): CancelablePromise<Array<{
    id: 'active' | 'cancelled' | 'expired' | 'pending' | 'planning' | 'pricing' | 'reservation' | 'review' | 'temporary';
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/campaign/status/list',
    });
  }

  /**
   * Method that returns possible campaign types
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCampaignTypeList(): CancelablePromise<Array<{
    id: string;
    name: string;
    is_public: boolean;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/campaign/type/list',
    });
  }

  /**
   * Method that associate a user tag to a campaign
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaignUsertag(
    requestBody: {
      campaign_id: number;
      user_tag_id: number;
    },
  ): CancelablePromise<{
    campaign_id: number;
    user_tag_id: number;
    user_tag: {
      name: string;
    };
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign/usertag',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that creates a campaign venue type
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaignVenuetype(
    requestBody: {
      id?: number;
      campaign_id: number;
      venue_type_id: number;
      created_at?: string;
    },
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    venue_type_id: number;
    created_at: string;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign/venuetype',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that creates a campaign weather
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCampaignWeather(
    requestBody: {
      id?: number;
      campaign_id: number;
      weather_id: 'thunderstorm' | 'drizzle' | 'rain' | 'snow' | 'atmosphere' | 'clear' | 'clouds';
      created_at?: string;
    },
  ): CancelablePromise<{
    id: number;
    campaign_id: number;
    weather_id: 'thunderstorm' | 'drizzle' | 'rain' | 'snow' | 'atmosphere' | 'clear' | 'clouds';
    created_at: string;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/campaign/weather',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

}
